import type { Action, PlacementType, SearchType } from 'lib/sdks/ad-server';
import { notifyClick, notifyImpression } from 'lib/sdks/ad-server';
import { track } from 'lib/sdks/analytics';
import { useEffect } from 'react';
export { Action } from 'lib/sdks/ad-server';

type AdServerParams = {
  isSponsored?: boolean;
  isVisible?: boolean;
  trackingId?: string;
  companyId?: number;
  searchType?: SearchType;
  placementType?: PlacementType;
  campaignId?: string;
  rank?: number;
};

export const handleSponsoredClick = (
  action: Action,
  {
    isSponsored = false,
    trackingId,
    companyId,
    searchType,
    placementType,
    campaignId,
    rank = 0,
  }: AdServerParams,
) => {
  if (!isSponsored || !trackingId) return;

  track('media.sponsored_click', {
    trader_id: companyId,
    campaign_id: campaignId,
    tracking_id: trackingId,
    campaign_type: 'MdpSponsoredSearch',
    search_type: searchType,
    placement_type: placementType,
    rank,
    action,
  });

  notifyClick(action, trackingId, rank);
};

export const useAdServer = ({
  isSponsored = false,
  isVisible = false,
  trackingId,
  companyId,
  searchType,
  placementType,
  campaignId,
  rank = 0,
}: AdServerParams = {}) => {
  useEffect(() => {
    if (!isSponsored || !trackingId || !isVisible) return;

    const timeoutId = setTimeout(() => {
      track('media.sponsored_impression', {
        trader_id: companyId,
        campaign_id: campaignId,
        tracking_id: trackingId,
        campaign_type: 'MdpSponsoredSearch',
        search_type: searchType,
        placement_type: placementType,
        rank,
      });

      notifyImpression(trackingId, rank);
    }, 1000);

    return () => clearTimeout(timeoutId);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSponsored, trackingId, isVisible]);

  const onClick = (action: Action) =>
    handleSponsoredClick(action, {
      isSponsored,
      trackingId,
      companyId,
      searchType,
      placementType,
      campaignId,
      rank,
    });

  return { onClick };
};
